import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { useT } from "@/lib/i18n";
import { Loader2 } from "lucide-react";

export default function Dashboard() {
  const { user } = useAuth();
  const { lang } = useT();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) { navigate("/login?next=/dashboard", { replace: true }); return; }
    if (user.role === "admin") { window.location.replace("https://geovinum.io/admin"); return; }
    if (user.plan === "pro") { navigate("/pro/dashboard", { replace: true }); return; }
    if (user.plan === "amateur" || user.subscription_active) { navigate("/play/rewards", { replace: true }); return; }
    navigate("/pricing", { replace: true });
  }, [user, navigate]);

  return (
    <div className="max-w-2xl mx-auto px-5 py-16 flex items-center gap-2 text-[#8B95A1]" data-testid="dashboard-router">
      <Loader2 className="w-5 h-5 animate-spin" />
      {lang === "fr" ? "Redirection vers votre tableau de bord…" : "Redirecting to your dashboard…"}
    </div>
  );
}
